import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { InsuranceProviderFormData } from "../interfaces/insuranceProviders";
import { camelToSnake } from "../utils/CamelToSnake";

export const createInsuranceProvider = (payload: InsuranceProviderFormData) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/insurance-providers`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getInsuranceProviders = (params?: any) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/insurance-providers`, { params })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getInsuranceProviderById = (id: number | string) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/insurance-providers/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const updateInsuranceProvider = (
  id: number | string,
  payload: InsuranceProviderFormData
) => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/insurance-providers/${id}`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// Claim templates — nested under a provider

export const getClaimTemplates = (providerId: number) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/insurance-providers/${providerId}/claim-templates`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const createClaimTemplate = (providerId: number, payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .post(
        `${BASE_URL}/api/v1/insurance-providers/${providerId}/claim-templates`,
        camelToSnake(payload)
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const updateClaimTemplate = (
  providerId: number,
  templateId: number,
  payload: any
) => {
  return new Promise((resolve, reject) => {
    api
      .put(
        `${BASE_URL}/api/v1/insurance-providers/${providerId}/claim-templates/${templateId}`,
        camelToSnake(payload)
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const deleteClaimTemplate = (providerId: number, templateId: number) => {
  return new Promise((resolve, reject) => {
    api
      .delete(
        `${BASE_URL}/api/v1/insurance-providers/${providerId}/claim-templates/${templateId}`
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};
